/**
 * Configuración de la tabla de usuarios
 */
export const USER_TABLE_CONFIG = {
  /** Tamaño de página por defecto */
  defaultPageSize: 10,
  
  /** Opciones de tamaño de página disponibles */
  pageSizeOptions: [5, 10, 25, 50, 100],
  
  /** Mostrar selector de tamaño de página */
  showPageSizeOptions: true,
  
  /** Mostrar información de rango de elementos */
  showFirstLastButtons: true
};
